
import { defineComponent, ref } from 'vue'
import { useStore } from '@/store/index'
import LayoutAuthSidebarContent from '@/components/LayoutAuthSidebarContent.vue'

export default defineComponent({
  components: { LayoutAuthSidebarContent },
  setup() {
    const store = useStore()
    const dimmer = ref(true)

    return {
      store,
      dimmer
    }
  },
})
